var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocalWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.959,
    height: 19.306,
    viewBox: "0 0 28.959 19.306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18378",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18378",
    transform: "translate(-1090.096 -677.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_28373",
    "data-name": "\\u30D1\\u30B9 28373",
    d: "M24.133,24.893a2.42,2.42,0,0,0,2.413-2.413V10.413A2.42,2.42,0,0,0,24.133,8H4.827a2.42,2.42,0,0,0-2.413,2.413V22.48a2.42,2.42,0,0,0,2.413,2.413H0v2.413H28.959V24.893ZM4.827,10.413H24.133V22.48H4.827Z",
    transform: "translate(1090.096 669.066)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Download",
    d: "M22.881,31.807l-1.233,1.243V27.706a.956.956,0,1,0-1.912,0v5.344L18.5,31.807a.96.96,0,0,0-1.357,1.357l2.868,2.868a.956.956,0,0,0,.315.2.9.9,0,0,0,.727,0,.956.956,0,0,0,.315-.2l2.868-2.868a.96.96,0,0,0-1.357-1.357Z",
    transform: "translate(1084.008 654.197)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalWhite);
export default __webpack_public_path__ + "static/media/localWhite.719f0db88e5d84f984e3f10425da7849.svg";
export { ForwardRef as ReactComponent };